import React from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import { styled } from "@/styles/theme"

const StyledA = styled("a", {
  cursor: "pointer",
  padding: "16px 24px 8px 16px",
  marginBottom: 16,
  whiteSpace: "nowrap",
  color: "$slate",
  fontWeight: 500,
  fontSize: 16,
  variants: {
    disabledVariant: {
      true: {
        background: "none !important",
        color: "$gray-light",
        cursor: "not-allowed",
      },
    },
    selectedVariant: {
      true: {
        fontWeight: 600,
        borderBottom: "$blue",
        borderBottomWidth: 3,
        borderBottomStyle: "solid",
      },
    },
  },
})

function MenuItem({ path, label, disabled }) {
  const { pathname } = useRouter()
  const isSelected = path === pathname

  return (
    <Link href={path} passHref>
      <StyledA
        selectedVariant={isSelected}
        disabledVariant={disabled}
        onClick={(e) => disabled && e.preventDefault()}
      >
        {label}
      </StyledA>
    </Link>
  )
}

export default MenuItem
